import { Card, Descriptions, Space, Tag, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { ROLE_COLOR, ROLE_LABEL, normalizeRoles, rolesLabel } from '@/domain/roles';
import { useSessionStore } from '@/store/session';

const { Paragraph, Text, Title } = Typography;

/**
 * 概览 —— 兼「我的资料」。
 *
 * 两个页面合并成一个：原来的「我的资料」只有组织 / 邮箱 / 角色三行加一个改名框，
 * 而概览页说的正是同一件事（你是谁、在哪个组织、能做什么）。拆成两页的唯一理由是
 * 那个改名框，改名收归管理员之后，这一页**全部只读**，没有再拆开的必要。
 *
 * 🔴 姓名在这里**不可编辑**：它是组织内的显示名，只有管理员能设置
 * （见 backend/src/modules/members/members.service.ts 的 updateMemberName）。
 */
export default function Home() {
  const me = useSessionStore((s) => s.me);
  if (!me) return null;

  const isAdmin = me.roles.includes('admin');

  return (
    <Card style={{ maxWidth: 640 }}>
      <Title level={4} style={{ marginTop: 0 }}>
        {me.organization.name}
      </Title>
      <Paragraph type="secondary">
        你好，{me.user.name}。当前身份是{rolesLabel(me.roles)}。
      </Paragraph>
      <Paragraph type="secondary" style={{ marginBottom: 24 }}>
        {isAdmin
          ? '你可以在「成员」页添加成员、设置姓名与角色。多个管理员之间完全平权。'
          : '需要调整成员、姓名或角色时，请联系组织管理员。'}
      </Paragraph>

      <Descriptions title="我的资料" column={1} size="small">
        <Descriptions.Item label="姓名">
          <Space size={8}>
            {me.user.name}
            <Text type="secondary" style={{ fontSize: 12 }}>
              {isAdmin ? (
                <>
                  由管理员设置，<Link to="/members">去成员页修改</Link>
                </>
              ) : (
                '由管理员设置，如需修改请联系管理员'
              )}
            </Text>
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label="邮箱">
          <Space size={8}>
            {me.user.email}
            <Text type="secondary" style={{ fontSize: 12 }}>
              登录凭据，不可修改
            </Text>
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label="角色">
          <Space size={4} wrap>
            {normalizeRoles(me.roles).map((r) => (
              <Tag key={r} color={ROLE_COLOR[r]} style={{ marginInlineEnd: 0 }}>
                {ROLE_LABEL[r]}
              </Tag>
            ))}
          </Space>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
